import {useMutation} from '@tanstack/react-query';

import {postOdontoBookingConfirm} from '../../services/postOdontoBookingConfirm';

export const usePostOdontoBookingConfirmMutation = () => {
	return useMutation({
		mutationFn: postOdontoBookingConfirm,
	});
};
